export const hasProperty = <K extends PropertyKey>(
  obj: object,
  key: K
): obj is Record<K, unknown> => {
  return key in obj;
};
